'use client';

import { useEffect } from 'react';

import { TooltipRootContext } from './context/tooltip-root.context';
import { useTooltip } from './hooks/use-tooltip';
import type { TooltipRootPropsInterface } from './types/tooltip-root.types';

/**
 * @since 10.0.0
 */
export const TooltipRoot = (props: TooltipRootPropsInterface) => {
  const { children, forceUpdateDependency, ...rest } = props;

  const tooltip = useTooltip(rest);

  useEffect(() => {
    tooltip.context.update();
  }, [tooltip.context, forceUpdateDependency]);

  return <TooltipRootContext.Provider value={{ tooltip }}>{children}</TooltipRootContext.Provider>;
};

TooltipRoot.displayName = 'Tooltip.Root';
